import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isFunction from 'lodash/isFunction';

import {
  showGlobalSpinner as showGlobalSpinnerAction,
  hideGlobalSpinner as hideGlobalSpinnerAction,
} from '@Containers/GlobalSpinner/GlobalSpinnerActions';
import { updateDialog as updateDialogAction } from '@Containers/Dialogs/DialogsActions';

import { getMolForStructure } from '../GSFNService';
import { typeOfGSFNNotFoundDialog } from '../GSFNNotFoundDialog';
import GSFNDialog from './GSFNDialog';

export function GSFNDialogContainer({
  onStructureLoaded,
  showGlobalSpinner,
  hideGlobalSpinner,
  selfClose,
  openNotFoundDialog,
  options,
  notFoundMessage,
}) {
  // store request in state, if it is WS it has 'cancel' method which needs to be called on self close
  const [activeRequest, setActiveRequest] = useState(null);
  const [substances, setSubstances] = useState(null);

  useEffect(() => {
    activeRequest ? showGlobalSpinner() : hideGlobalSpinner();
  }, [activeRequest]);

  const selfCloseHandler = () => {
    if (activeRequest) {
      // cancel request in case on WS
      isFunction(activeRequest.cancel) && activeRequest.cancel();
      setActiveRequest(null);
    }
    selfClose();
  };

  const onSubstanceSelectHandler = (substance) => {
    selfClose();
    onStructureLoaded(substance.structure);
  };

  const onInputEnterHandler = (textQuery, optionValue) => {
    // Prevent multi trigger
    if (activeRequest) {
      return;
    }

    setSubstances(null);

    const request = getMolForStructure(textQuery, optionValue)
      .then(({ substances: fetchedSubstances }) => {
        if (!fetchedSubstances || !fetchedSubstances.length) {
          openNotFoundDialog({ message: notFoundMessage });
        } else if (fetchedSubstances.length === 1) {
          onSubstanceSelectHandler(fetchedSubstances[0]);
        } else {
          setSubstances(fetchedSubstances);
        }
        setActiveRequest(null);
      })
      .catch((error) => {
        Logger.error(error);
        setActiveRequest(null);
      });

    setActiveRequest(request);
  };

  return (
    <GSFNDialog
      selfClose={selfCloseHandler}
      options={options}
      onInputEnter={onInputEnterHandler}
      substances={substances}
      onSubstanceSelect={onSubstanceSelectHandler}
    />
  );
}

GSFNDialogContainer.propTypes = {
  onStructureLoaded: PropTypes.func.isRequired,
  showGlobalSpinner: PropTypes.func.isRequired,
  hideGlobalSpinner: PropTypes.func.isRequired,
  selfClose: PropTypes.func.isRequired,
  openNotFoundDialog: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      isDisabled: PropTypes.bool,
    })
  ).isRequired,
  notFoundMessage: PropTypes.string,
};

const mapDispatchToProps = {
  showGlobalSpinner: showGlobalSpinnerAction,
  hideGlobalSpinner: hideGlobalSpinnerAction,
  openNotFoundDialog: (dialogProps = {}) =>
    updateDialogAction({
      id: typeOfGSFNNotFoundDialog,
      dialogType: typeOfGSFNNotFoundDialog,
      ...dialogProps,
    }),
};

export default connect(null, mapDispatchToProps)(GSFNDialogContainer);
